var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"Gross Profit","color":"green accent-1","amount":_vm.balanceTotal,"icon":"mdi-chart-multiple","sub_title":""}}),_c('stat-card',{attrs:{"title":"GST on Gross Profit","color":"green accent-1","amount":_vm.balanceGST,"icon":"mdi-chart-multiple","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }